import { render, staticRenderFns } from "./ItemPlannerItemPrice.vue?vue&type=template&id=31c6bab4&"
import script from "./ItemPlannerItemPrice.vue?vue&type=script&lang=js&"
export * from "./ItemPlannerItemPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports